import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Button as Btn,
  Typography,
} from "@material-ui/core";
import { Spinner } from "../../components";
import { useCookies } from "react-cookie";
import { DatabaseEntities } from "../../model/enum/database-entities.enum";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import US_States from "../../model/enum/states.us.enum";
import User from "../../model/user";
import DeleteUserModal from "./DeleteUserModal";
import AlertService from "../../service/AlertService";
import Pathnames from "../../model/enum/Pathnames";
import ApiService from "../../service/ApiService";
import Avatar from "../../shared/components/images/Avatar";
import ToastMessages from "../../model/enum/toast-messages.enum";
import useStyles from "./styles";
import styles from "../styles/cardStyles";
import { PrimaryColor } from "../../shared/styles/colors";

const UserProfile = () => {
  const classes = useStyles();
  const cardStyles = styles();
  const [cookies, setCookie, removeCookie] = useCookies(["session"]);

  const [user, setUser] = useState<User>();
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(true);

  var US_state = new US_States();

  //Get user info
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await ApiService.get<User>(
        `${DatabaseEntities.USERS}/${userId}`
      ).then((data) => {
        setUser(data);
      });
      
      setLoading(false);
    };

    if (!user && userId) fetchData();
  });

  const handleDelete = async () => {
    if (user) {
      setLoading(true);
      await ApiService.delete<any>(`${DatabaseEntities.USERS}/${user.id}`)
        .then(async () => {
          AlertService.success(ToastMessages.ACCOUNT_DELETED);
          removeCookie("session");
          setTimeout(() => {
            window.open(Pathnames.LOGIN, "_self");
            setLoading(false);
          }, 2000);
        })
        .catch(() => {
          AlertService.error("Error deleting account");
        });
    }
  };

  return (
    <>
      {!user || loading ? (
        <Spinner />
      ) : (
        <Card className={cardStyles.card}>
          <div className={cardStyles.headerContainer}>
            <Typography className={classes.title}>My profile</Typography>
            <DeleteUserModal handleDelete={handleDelete} />
          </div>
          <CardContent>
            <div className={classes.summaryDiv}>
              <Avatar name={`${user.firstName} ${user.lastName}`} />
              <div className={classes.summarySubDiv}>
                <Typography className={classes.boldedTex}>
                  {user.firstName} {user.lastName}
                </Typography>
                <Typography variant="subtitle2">
                  {user.city}, {US_state.getStateAbbreviation(user.zip)}
                </Typography>
              </div>
            </div>
            <div className={classes.borderedDiv}>
              <div className={classes.headerDiv}>
                <Typography className={classes.boldedTex}>
                  Personal information
                </Typography>
                <Btn className={classes.moreVertIcon}>
                  <MoreVertIcon sx={{ color: PrimaryColor}}/>
                </Btn>
              </div>
              <div className={classes.dividedContainer}>
                <div className={classes.subContainer}>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>
                      First name
                    </Typography>
                    <Typography className={classes.subTitle}>
                      {user.firstName}
                    </Typography>
                  </div>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>Email</Typography>
                    <Typography className={classes.subTitle}>
                      {user.email}
                    </Typography>
                  </div>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>Role</Typography>
                    <Typography className={classes.subTitle}>
                      {user.Role?.name}
                    </Typography>
                  </div>
                </div>
                <div className={classes.subContainer}>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>
                      Last name
                    </Typography>
                    <Typography className={classes.subTitle}>
                      {user.lastName}
                    </Typography>
                  </div>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>Phone</Typography>
                    <Typography className={classes.subTitle}>
                      {user.phone}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.borderedDiv}>
              <div className={classes.headerDiv}>
                <Typography className={classes.boldedTex}>Address</Typography>
                <Btn className={classes.moreVertIcon}>
                  <MoreVertIcon sx={{ color: PrimaryColor}}/>
                </Btn>
              </div>
              <div className={classes.dividedContainer}>
                <div className={classes.subContainer}>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>
                      Country
                    </Typography>
                    <Typography className={classes.subTitle}>
                      United States
                    </Typography>
                  </div>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>
                      Zip code
                    </Typography>
                    <Typography className={classes.subTitle}>
                      {user.zip}
                    </Typography>
                  </div>
                </div>
                <div className={classes.subContainer}>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>City</Typography>
                    <Typography className={classes.subTitle}>
                      {user.city}
                    </Typography>
                  </div>
                  <div className={classes.wrapedItems}>
                    <Typography className={classes.lightText}>State</Typography>
                    <Typography className={classes.subTitle}>
                      {user.state}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default UserProfile;
